import { escapeRegExp, forEach, isEmpty, keys } from 'lodash';

import {
    DisplayListItem,
    DisplayRegion,
    OutdoorDisplayListItem,
    PolygonData,
    SelectedScreens
} from '../../../typings/displayMap';
import { selectedFilters as easySelectedFilters } from '../../EasyFilters/EasyFilters';

export const OutdoorUtils = {
    getFilters: (screenGroupsByRegion: { [id: string]: DisplayListItem[] }) => {
        const operatorName = {};
        const facilityType = {};

        forEach(screenGroupsByRegion, (groups: DisplayListItem[]) => {
            groups.forEach((group: OutdoorDisplayListItem) => {
                if (!operatorName[group.operatorName]) {
                    operatorName[group.operatorName] = true;
                }

                if (!facilityType[group.facilityType]) {
                    facilityType[group.facilityType] = true;
                }
            });
        });

        return {
            operatorName: keys(operatorName),
            facilityType: keys(facilityType)
        };
    },

    filterScreenGroups: (
        screenGroupsByRegion: { [id: string]: DisplayListItem[] },
        selectedFilters: { [name: string]: easySelectedFilters },
        filteredRegions: DisplayRegion[],
        selectedScreens: SelectedScreens,
        polygonData: PolygonData,
        searchText: string
    ) => {
        return filteredRegions.reduce((result: { [id: string]: DisplayListItem[] }, region: DisplayRegion) => {
            result[region.id] = OutdoorUtils.filterRegion(
                screenGroupsByRegion[region.id],
                selectedFilters,
                selectedScreens[region.id] || [],
                polygonData,
                searchText
            );

            return result;
        }, {});
    },

    filterRegion: (
        groups: DisplayListItem[],
        selectedFilters: { [name: string]: easySelectedFilters },
        selectedScreens: string[],
        polygonData: PolygonData,
        searchText: string
    ): DisplayListItem[] => {
        if (selectedFilters.selected) {
            groups = groups.filter((group: DisplayListItem) => {
                return selectedScreens.includes(group.id);
            });
        }

        if (!isEmpty(selectedFilters.operatorName)) {
            groups = groups.filter((group: OutdoorDisplayListItem) => {
                const operatorName = group.operatorName;

                if (Array.isArray(selectedFilters.operatorName)) {
                    return selectedFilters.operatorName.includes(operatorName);
                } else {
                    return false;
                }
            });
        }

        if (!isEmpty(selectedFilters.facilityType)) {
            groups = groups.filter((group: OutdoorDisplayListItem) => {
                // TODO избавится от toString
                const facilityType = group.facilityType.toString();

                if (Array.isArray(selectedFilters.facilityType)) {
                    return selectedFilters.facilityType.includes(facilityType);
                } else {
                    return false;
                }
            });
        }

        if (!isEmpty(polygonData.polygons) && polygonData.polygons && polygonData.polygons.getLength()) {
            groups = OutdoorUtils.getScreensInPolygons(polygonData, groups);
        }

        if (searchText) {
            const regExpTest: RegExp = new RegExp(escapeRegExp(searchText), 'i');

            groups = groups.filter((displayListItem: DisplayListItem) => {
                const title = displayListItem.caption.toString();
                const subtitle = displayListItem.address.toString();
                const id = displayListItem.id.toString();
                const gid = displayListItem.gid;
                const operatorName = 'operatorName' in displayListItem ? displayListItem.operatorName : undefined;

                return (
                    regExpTest.test(title) ||
                    regExpTest.test(subtitle) ||
                    regExpTest.test(id) ||
                    (gid && regExpTest.test(gid)) ||
                    (operatorName && regExpTest.test(operatorName))
                );
            });
        }

        return groups;
    },

    getScreensInPolygons: (polygonData: PolygonData, groups: DisplayListItem[]) => {
        const filteredScreens: DisplayListItem[] = [];
        const polygons = polygonData.polygons;

        if (polygonData.isDrawEnabled) {
            return groups;
        }

        if (polygons) {
            polygons.each((geoObject: ymaps.GeoObject) => {
                filteredScreens.push(
                    ...groups.filter((group: DisplayListItem) => {
                        // @ts-ignore
                        return geoObject.geometry.contains(group.coordinates);
                    })
                );
            });
        }

        return filteredScreens;
    }
};
